export class ReferenceDataEditionError extends Error {
    constructor(message = 'Error while editing road sections') {
        super(message);
        this.name = 'ReferenceDataEditionError';
    }
}
